import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition,
	OptionType
} from '@evinced-private/ui-common';

import { DEFAULT_UNIT_ID_DISPLAY_NAME } from 'src/common/consts/platformConfigConsts';
import { DEFAULT_PERIOD_OPTION } from 'src/common/helpers/DataFilterHelper';
import { DevelopmentToggles, getSingleToggle } from 'src/common/services/TogglesService';

import {
	ENVIRONMENT_FILTER_LABELS,
	LABELS_FILTER_LABELS,
	PROPERTIES_FILTER_LABELS,
	SEARCH_FILTER_LABELS,
	TEST_PERIOD_FILTER_LABELS,
	UNIT_ID_FILTER_LABELS
} from '../../types/filter-section-v2';

const enableWebSdkProperties = getSingleToggle(DevelopmentToggles.ENABLE_WEB_SDK_PROPERTIES);

const searchFilter: ITextFilterDefinition = {
	id: SEARCH_FILTER_LABELS.id,
	label: SEARCH_FILTER_LABELS.label,
	filterType: 'text',
	defaultValue: '',
	componentProps: {
		placeholder: SEARCH_FILTER_LABELS.placeholder
	}
};

const propertiesFilter: ISelectFilterDefinition = {
	id: PROPERTIES_FILTER_LABELS.id,
	label: PROPERTIES_FILTER_LABELS.label,
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: PROPERTIES_FILTER_LABELS.placeholder,
		someItemsSelectedText: PROPERTIES_FILTER_LABELS.someItemsSelectedText,
		isMultiple: true,
		className: PROPERTIES_FILTER_LABELS.className,
		id: PROPERTIES_FILTER_LABELS.id,
		label: PROPERTIES_FILTER_LABELS.componentLabel,
		listboxWidth: PROPERTIES_FILTER_LABELS.listboxWidth
	}
};

export const getWebSdkTestsFilterDefinitionsV2 = (
	unitIdDisplayName: string = DEFAULT_UNIT_ID_DISPLAY_NAME,
	labelsLoadOptions?: (searchText: string, callback: (options: OptionType[]) => void) => void,
	labelsOptions?: OptionType[]
): IFilterDefinition[] => {
	const environmentFilter: ISelectFilterDefinition = {
		id: ENVIRONMENT_FILTER_LABELS.id,
		label: ENVIRONMENT_FILTER_LABELS.label,
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: ENVIRONMENT_FILTER_LABELS.placeholder,
			someItemsSelectedText: ENVIRONMENT_FILTER_LABELS.someItemsSelectedText,
			isMultiple: true,
			className: ENVIRONMENT_FILTER_LABELS.className,
			id: ENVIRONMENT_FILTER_LABELS.id,
			label: ENVIRONMENT_FILTER_LABELS.componentLabel
		}
	};

	const unitIdFilter: ISelectFilterDefinition = {
		id: UNIT_ID_FILTER_LABELS.id,
		label: UNIT_ID_FILTER_LABELS.label,
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: UNIT_ID_FILTER_LABELS.placeholderPrefix,
			allSelectedPlaceholder: `${UNIT_ID_FILTER_LABELS.allSelectedPrefix} ${unitIdDisplayName}s`,
			someItemsSelectedText: UNIT_ID_FILTER_LABELS.someItemsSelectedPrefix(unitIdDisplayName),
			isMultiple: true,
			className: UNIT_ID_FILTER_LABELS.className,
			id: UNIT_ID_FILTER_LABELS.id,
			label: unitIdDisplayName
		}
	};

	const labelsFilter: ISelectFilterDefinition = {
		id: LABELS_FILTER_LABELS.id,
		label: LABELS_FILTER_LABELS.label,
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: LABELS_FILTER_LABELS.placeholder,
			someItemsSelectedText: LABELS_FILTER_LABELS.someItemsSelectedText,
			isMultiple: true,
			className: LABELS_FILTER_LABELS.className,
			id: LABELS_FILTER_LABELS.id,
			label: LABELS_FILTER_LABELS.componentLabel,
			...(labelsLoadOptions && { loadOptions: labelsLoadOptions }),
			...(labelsOptions && { options: labelsOptions }),
			...(labelsLoadOptions && { isSearchable: true })
		}
	};

	const testPeriodFilter: ISelectFilterDefinition = {
		id: TEST_PERIOD_FILTER_LABELS.id,
		label: TEST_PERIOD_FILTER_LABELS.label,
		filterType: 'select',
		defaultValue: [DEFAULT_PERIOD_OPTION],
		componentProps: {
			placeholder: TEST_PERIOD_FILTER_LABELS.placeholder,
			isMultiple: false,
			id: TEST_PERIOD_FILTER_LABELS.id,
			label: TEST_PERIOD_FILTER_LABELS.componentLabel
		}
	};

	return [
		searchFilter,
		unitIdFilter,
		environmentFilter,
		labelsFilter,
		...(enableWebSdkProperties ? [propertiesFilter] : []),
		testPeriodFilter
	];
};
